import React from 'react';
import ExternalSvg from 'components/ExternalSvg';

const ShakeShackHotDrink = () => (
  <ExternalSvg customer="shakeshack" iconName="hotdrink" width="100%" height="90%" />
);

export default ShakeShackHotDrink;
